import React, { useState } from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UISelect from 'components/selectbox/UISelect';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";
import StringUtil from "utils/StringUtil";
import UIDatePicker from "components/datepicker";
import UIUtils from "utils/UIUtils";
import codeDataStore from "common/codedata/store/CodeDataStore";
import message from "common/message/source/MessageSource";
import userStore from "common/user/store/UserStore";
import axios, {AxiosRequestConfig} from "axios";
import BooleanUtil from 'utils/BooleanUtil';

function ContentsContainer() {

	//사용자ID
	const personId = userStore.userModel?.getPersonId();

	const modaladm6611 = useToggleState({});
	const modaladm6612 = useToggleState({});
	const modaladm6613 = useToggleState({});
	const modaladm6614 = useToggleState({});
	const modaladm6615 = useToggleState({});
	const modaladm6616 = useToggleState({});

	const [modaladm6614Open, setModaladm6614Open] = useState(false); //코드조회 팝업오픈여부
	const [modaladm6615Open, setModaladm6615Open] = useState(false); //사업연결 팝업오픈여부
	const [modaladm6616Open, setModaladm6616Open] = useState(false);  //사업연결 팝업오픈여부 

	const [totalRowCnt,setTotalRowCnt] = useState(0);  //통계목관리 전체건수
	const [showRowCnt,setShowRowCnt] = useState(20)    

	const [codeTotalRowCnt,setCodeTotalRowCnt] = useState(0);  //코드조회 전체건수
	const [codeShowRowCnt,setCodeShowRowCnt] = useState(20)   
	
	const [corpTotalRowCnt,setCorpTotalRowCnt] = useState(0);  //기업조회 전체건수
	const [corpShowRowCnt,setCorpShowRowCnt] = useState(20)  

	const [isChecked,setIsChecked] = useState(false);  //체크여부 
	const [checkedItems,setCheckedItems] = useState(new Set());  //체크된 요소들
	const [useYn,setUseYn] = useState(null)  
	const [searchText,setSearchText] = useState('')
	const [bizCd,setBizCd] = useState('');
	const [anctTpCd,setAnctTpCd] = useState('');
	const [yyyy,setYyyy] = useState(String(new Date().getFullYear()));
	const [codeYyyy,setCodeYyyy] = useState(String(new Date().getFullYear()));
	const [searchYyyy,setSearchYyyy] = useState(String(new Date().getFullYear()));
	
	
	const [anctACd,setAnctACd] = useState('');   //세부사업
	const [anctACdNm,setAnctACdNm] = useState('');   //세부사업
	const [anctBCd,setAnctBCd] = useState('');   //편성목
	const [anctBCdNm,setAnctBCdNm] = useState('');   //편성목
	const [anctCCd,setAnctCCd] = useState('');   //통계목
	const [anctCCdNm,setAnctCCdNm] = useState('');   //통계목

	const [codeBizCd,setCodeBizCd] = useState('');   //코드
	const [codeAnctDivCd,setCodeAnctDivCd] = useState('');   //코드
	const [codeAnctCd,setCodeAnctCd] = useState('');   //코드
	const [codeAnctNm,setCodeAnctNm] = useState('');   //코드명
	const [codeNotes,setCodeNotes] = useState('');   //비고 
	const [anctDivCd,setAnctDivCd] = useState('');   //코드구분
	
	
	//통계목 코드 목록 검색조건 
	const [searchCodeAcntCd, setSearchCodeAcntCd] = useState('');   //코드번호
	const [searchCodeAcntNm, setSearchCodeAcntNm] = useState('');   //코드명
	const [searchCodeAnctDivCd, setSearchCodeAnctDivCd] = useState('');   //코드명

    //기업 검색 검색조건
	const [searchCorpNm, setSearchCorpNm] = useState('');   //기업명 
	const [searchBizNo, setSearchBizNo] = useState('');   // 사업자번호 


	//사업연결 파라미터 
	const [userBizCd,setUserBizCd] = useState('');   // 사업코드
	const [userAnctACd,setUserAnctACd] = useState('');   // 사업 세부사업
	const [userAnctBCd,setUserAnctBCd] = useState('');   // 사업 편성목코드
	const [userAnctCCd,setUserAnctCCd] = useState('');   // 사업 통계목코드
	const [userNotes,setUserNotes] = useState('');   // 사업연결 비고 
	const [userYyyy,setUserYyyy] = useState('');   // 사업년도
	const [userCorpNm,setUserCorpNm] = useState('');   // 사업연결 기업명
	const [userBizNo,setUserBizNo] = useState('');   // 사업연결 기업 사업자번호
	

	const [corpNm,setCorpNm] = useState('');   // 기업명 
	const [notes,setNotes] = useState('');   // 기업명 

	const initStartDate = new Date().getFullYear()-5;
	const initEndDate = new Date().getFullYear()+1;
	
	var yearArr: number[] = [];
	
	for (let year = initEndDate; year >= initStartDate; year--) {
	  yearArr.push(year);
	}

	const location = useLocation();
	const receivedData = (location.state as any)?.data;
  	const history = useHistory();

	/**ibsheet 세팅  */
    //초기 데이터 설정
	let totalCnt:number = 0;
	let totalCodeCnt:number = 0;
	let totalCorpCnt:number = 0;
	let rowCnt:number = 0;
	let rowCodeCnt:number = 0;
	let rowCorpCnt:number = 0;

	let SubjManageListData = {};
	let SubjCodePopData = {};
	let SubjCorpPopData = {};

	//====== 그리드 공통 부 START
	var ib = ib||{};
	ib = {
		//시트 초기화 구문
		'init':{
				"SubjManageList": {  //통계목 관리
					//공통기능 설정 부분
					"Cfg": {
						"SearchMode": 1,
						"PageLength": showRowCnt,
						"AutoRowHeight": 1,
						"InfoRowConfig": "0",
						"Alternate":"0",
						"HeaderCheck": 1,  // Type이 Bool인 열의 헤더에 체크박스를 생성합니다.
						"HeaderCheckMode": 1, // 시트에 보이는 행에 대해 체크합니다(필터링되거나, 행이 Visible 0일 때 체크가 되지 않습니다)
					},
					
					//틀고정 좌측 컬럼 설정
				    "LeftCols": [
						{"Header": "No","Name": "SEQ","Width": "30"}
					],
					"Cols": [
						{"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 0.5,"CanEdit": "0"},
						{"Header": { "Value": "", "HeaderCheck": 1,  "IconAlign": "Center"	},"Type": "Bool","Name": "CheckData","Width": 80,"Align": "Center",	"CanEdit": 1 },
						{"Header": "세부사업코드","Type": "Text","Name": "ANCT_A_CD","RelWidth": 1,"Align": "Center","CanEdit": "0"},
						{"Header": "세부사업(명칭)","Type": "Text","Name": "ANCT_A_CD_NM","RelWidth": 1,"Align": "Center","CanEdit": "0"},
						{"Header": "편성목코드","Type": "Text","Name": "ANCT_B_CD","RelWidth": 0.5,"Align": "Center","CanEdit": "0"},
						{"Header": "편성목(명칭)","Type": "Text","Name": "ANCT_B_CD_NM","RelWidth": 1.5,"Align": "Center","CanEdit": "0"},
						{"Header": "통계목코드","Type": "Text","TextStyle": 4,"Name": "ANCT_C_CD","RelWidth": 1,"Align": "Center","CanEdit": "0"},
						{"Header": "통계목(명칭)","Type": "Text","Name": "ANCT_C_CD_NM","RelWidth": 1,"Align": "Center","CanEdit": "0"},
						{"Header": "출연기업","Type": "Text","Name": "BIZ_NAME","RelWidth": 1,"Align": "Center","CanEdit": "0"},
						{"Header": {"Value": "비고사항" ,"Color": "#FFDFDF"},"Type": "Text","Name": "NOTES","RelWidth": 1,"Align": "Center","CanEdit": 0},
						{"Header": {"Value": "사용여부" ,"Color": "#FFDFDF"},"Type": "Enum","Name": "USE_YN","RelWidth": 0.5,"Align": "Center","CanEdit": 0,"Enum": "|사용|미사용","EnumKeys": "|Y|N"}
					]
			},
			"SubjCodePop": {  //코드조회
				"Cfg": {
					"SearchMode": 3,
					//"PageLength": 20,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate":"0"
				},
				"Cols": [
					{"Header": "년도","Type": "Text","Name": "YYYY","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 1, "Hidden" : 1},
						{"Header": "코드구분","Type": "Text","Name": "ANCT_DIV_CD","MinWidth": 50,"Align": "Center","CanEdit": 0,"RelWidth": 0.5},
						{"Header": "코드번호","Type": "Text","Name": "ANCT_CD","MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 1},
						{"Header": "코드명","Type": "Text","Name": "ANCT_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 1.5},
						{"Header": "등록일시","Type": "Text","Name": "REG_DATE","RelWidth": 1.5,"Align": "Center","CanEdit": "0"}
				]
			},
			"SubjCorpPop": {  //기업조회 
				"Cfg": {
					"SearchMode": 1,
					"PageLength": 20,
					"AutoRowHeight": 1,
					"InfoRowConfig": "0",
					"Alternate":"0"
				},
				"Cols": [
					{"Header": "사업자등록번호","Type": "Text","CustomFormat": "###-##-#####","Name": "BIZ_NO","RelWidth": 2,"Align": "Center","CanEdit": "0"},
					{"Header": "기업명","Type": "Text","Name": "CORP_NM","MinWidth": 50,"Align": "Left","CanEdit": 0,"RelWidth": 1, "Hidden" : 1},
					{"Header": "대표자","Type": "Text","Name": "CEO_NM","MinWidth": 60,"Align": "Center","CanEdit": 0,"RelWidth": 1},
					{"Header": "규모","Type": "Text","Name": "CORP_SIZE_CD_NM","MinWidth": 40,"Align": "Center","CanEdit": 0,"RelWidth": 0.5}
				]
			}
		},

		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {
				var sheet = evtParam.sheet;
				if(sheet.id === "SubjManageList"){
					//초기 데이터 로딩
					doSearch();
				}else if(sheet.id === "SubjCodePop"){
					codeSearch();
				}
				else if(sheet.id === "SubjCorpPop"){
					corpSearch();
				}
			},
			//시트 클릭시 이벤트 처리
			onAfterClick:function(evtParam){			
				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					var row = sheet.getFocusedRow();

					CheckAllChecked(sheet , "CheckData");  //셀 선택시 체크박스 토글 

				
					if(sheet.id === "SubjManageList"){  
						if(evtParam.col == "ANCT_C_CD" ){   // 리스트에서 통계목 코드 클릭시 
							sheet.selectRow( row, 1);
							setCodeBizCd(row["BIZ_CD"])
							setAnctTpCd(row["ANCT_TP_CD"]);
							setAnctACd(row["ANCT_A_CD"]);
							setAnctBCd(row["ANCT_B_CD"]);
							setAnctCCd(row["ANCT_C_CD"]);
							setAnctCCdNm(row["ANCT_C_CD_NM"]);
							setCorpNm(row["BIZ_NAME"]);
							setNotes(row["NOTES"]);

							modaladm6611.open();
						}
					}else if(sheet.id === "SubjCodePop"){  //코드조회에서 클릭시

					}else if(sheet.id === "SubjCorpPop"){  //기업조회에서 클릭시 
						if(evtParam.col == "CORP_NM" ){
							sheet.selectRow( row, 1);
							setUserCorpNm(row["CORP_NM"]);
							setUserBizNo(row["BIZ_NO"]);

							modaladm6616Close(); //기업조회 팝업닫기 

						}
					}
				}

		    },	

			onDblClick:function(evtParam){     //더블 클릭시 
				if(evtParam.kind != "Header"){
					var sheet = evtParam.sheet;
					if(sheet.id === "SubjManageList"){  
						if(evtParam.col == "NOTES" ){
							var fRows = sheet.getFocusedRow();   //시트값 체크
							//@ts-ignore  
							sheet.setAttribute(fRows, "NOTES", "CanEdit", 1, 1);  

						}

						if(evtParam.col == "USE_YN" ){
							var fRows = sheet.getFocusedRow();   //시트값 체크
							//@ts-ignore  
							sheet.setAttribute(fRows, "USE_YN", "CanEdit", 1, 1);  

						}
					}else if(sheet.id === "SubjCodePop"){  
						if(evtParam.col == "ANCT_NM" ){
							var fRows = sheet.getFocusedRow();   //시트값 체크
							//@ts-ignore  
							sheet.setAttribute(fRows, "ANCT_NM", "CanEdit", 1, 1);  
						}
					}
				}
			},
			onAfterEdit:function (evtParam) {   //편집이 끝났을때 
				// 편집 종료 후에 발생합니다.
				var sheet = evtParam.sheet;

				if(sheet.id === "SubjManageList"){  
					if(evtParam.col == "NOTES" ){
						var fRows = sheet.getFocusedRow();   //시트값 체크
						//@ts-ignore  
						sheet.setAttribute(fRows, "NOTES", "CanEdit", 0, 1);  
					}
					
					if(evtParam.col == "USE_YN" ){
						var fRows = sheet.getFocusedRow();   //시트값 체크
						//@ts-ignore  
						sheet.setAttribute(fRows, "USE_YN", "CanEdit", 0, 1);  
					}
				}else if(sheet.id === "SubjCodePop"){  
					if(evtParam.col == "ANCT_NM" ){
						var fRows = sheet.getFocusedRow();   //시트값 체크
						//@ts-ignore  
						sheet.setAttribute(fRows, "ANCT_NM", "CanEdit", 0, 1);  
						sheet.selectRow( fRows, 1);
						let codeNm = evtParam.val;
						let param = {
							"ANCT_CD": fRows["ANCT_CD"]
							,"ANCT_DIV_CD": fRows["ANCT_DIV_CD"]
							,"ANCT_NM": codeNm   //코드명만 수정가능 
							,"YYYY": fRows["YYYY"]
						}

						if ( fRows["Changed"] !== undefined && fRows["Changed"]  === 1  ){
							updateSubjCode(param);  //통계목 코드 수정
						}	

						
					}
				}
			  },

			onMouseOver:function(evtParam){
				var sheet = evtParam.sheet;
				if (evtParam.row && evtParam.col && evtParam.orow && evtParam.ocol) {

				}
			},

			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;
		
				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
				_data = JSON.stringify(d.slice(0, 20), null, 2);
				_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
				_data = JSON.stringify(d, null, 2);
				}
				
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				if(sheet.id === "SubjManageList"){  
					//@ts-ignore
					var page = SubjManageList.getPageIndex(SubjManageList.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "M");
					}
				}else if(sheet.id === "SubjCodePop"){  
					//@ts-ignore
					var page = SubjCodePop.getPageIndex(SubjCodePop.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "C");
					}
				
				}else if(sheet.id === "SubjCorpPop"){  
					//@ts-ignore
					var page = SubjCorpPop.getPageIndex(SubjCorpPop.getFocusedPage()) + 1;
					//@ts-ignore
					if (currentPage != -1 && currentPage != page) {
						makePageIndex(page, "B");
					}
				}
				
			}
		},
		//시트객체 생성
		'create':function () {
			var options = this.init.SubjManageList;

			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'SubjManageList', // 생성할 시트의 id
				el: 'SubjManageListDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: SubjManageListData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		//시트객체 생성
		'createSubjCodePop':function () {
			var options2 = this.init.SubjCodePop;
			options2.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'SubjCodePop', // 생성할 시트의 id
				el: 'SubjCodePopDiv', // 시트를 생성할 Dom 객체 및 id
				options: options2, // 생성될 시트의 속성
				data: SubjCodePopData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		//시트객체 생성
		'createSubjCorpPop':function () {
			var options3 = this.init.SubjCorpPop;
			options3.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'SubjCorpPop', // 생성할 시트의 id
				el: 'SubjCorpPopDiv', // 시트를 생성할 Dom 객체 및 id
				options: options3, // 생성될 시트의 속성
				data: SubjCorpPopData // 생성될 시트의 정적데이터
			});

			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},

		'checkHandler':function ({target}) {
			//@ts-ignore
			IBSheet.SubjManageList.getRowData();
		},
		
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.SubjManageList.down2Excel({fileName: "통계목관리_"+today+".xlsx"});
		},
		//조회 데이터
		'data':[],
		'data2':[]
	}
	
	//====== 그리드 공통 부  END
	
	//체크 박스 체크
	function CheckAllChecked(sheet, col) {
		var row = sheet.getFocusedRow();

		var sdate = sheet.getValue( row , col );
		if(BooleanUtil.toBoolean(sdate)){
			sheet.setCheck(row, col, 0);
		}else{
			sheet.setCheck(row, col, 1);
		}
	}
	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number, divCd:string) {
	try {
		if (tp == null) {
			//@ts-ignore
			currentPage = -1;
			return;
		}

		// @ts-ignore
		currentPage = tp;
		// @ts-ignore
		let sr = 0; // 전체 조회 건수
		let page = 20;

		
		
		if(divCd =="M"){
			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}

		   // sr = totalCnt; // 전체 조회 건수
		   // @ts-ignore
		   //page = rowCnt; // 페이지당 레코드 수

		   // @ts-ignore
		   sr = SubjManageList.getTotalRowCount(); // 전체 조회 건수
		   // @ts-ignore
		   page = SubjManageList.PageLength; // 페이지당 레코드 수
		   
		}else if(divCd =="C"){
			sr = totalCodeCnt; // 전체 조회 건수
		   // @ts-ignore
		   page = rowCodeCnt; // 코드조회 레코드 수
		}else if(divCd =="B"){
			// @ts-ignore
			if (document.getElementById('pageNaviCorp').firstChild) {
				// @ts-ignore
				document.getElementById('pageNaviCorp').removeChild(document.getElementById('pageNaviCorp').firstChild);
			}

			sr = totalCorpCnt;
		   // @ts-ignore
		   page = rowCorpCnt; // 기업조회 레코드 수
		}
		let thispage = tp; // 현재 페이지
		let pagecnt = 5; // 한번에 표시할 페이지 개수
		let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
		let li, tt, a;
		let ul = document.createElement('DIV');
		// @ts-ignore
		ul.style.textAlign = 'center';

		let k = 1;

		if (thispage !== 1) {
		let ul_sub = document.createElement('DIV');
		ul_sub.className ="group";
		li = document.createElement('Button');
		li.className = 'item first';
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		tt = document.createTextNode('<<');
		addEventHandler(li, 'click', pageMove, 1, divCd);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub.appendChild(li)
		ul.appendChild(ul_sub);
		
		li = document.createElement('Button');
		li.className = 'item prev';
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		addEventHandler(li, 'click', pageMove, tp - 1, divCd);
		tt = document.createTextNode('<');
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub.appendChild(li)
		ul.appendChild(ul_sub);
		}

		sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
		let ul_sub2 = document.createElement('DIV');
		ul_sub2.className ="group";
		for (let i = sr; i < (sr + pagecnt); i++) {
		if (i <= lastpage) {
			li = document.createElement('Button');
			li.className ="item";
			a = document.createElement('a');
			a.style.cursor = 'pointer';
			tt = document.createTextNode(String(i));
			addEventHandler(li, 'click', pageMove, i, divCd);
			if (i === tp) {
			li.className ="item active";
			}
			a.appendChild(tt);
			li.appendChild(a);
			ul_sub2.appendChild(li);
			ul.appendChild(ul_sub2);
		}
		}

		if (thispage < lastpage) {
		let ul_sub3 = document.createElement('DIV');
		ul_sub3.className ="group";	
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		li = document.createElement('Button');
		li.className = 'item next';
		tt = document.createTextNode('>');
		addEventHandler(li, 'click', pageMove, tp + 1 ,divCd);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub3.appendChild(li);
		ul.appendChild(ul_sub3);
		
		li = document.createElement('Button');
		li.className = 'item last';
		tt = document.createTextNode('>>');
		a = document.createElement('a');
		a.style.cursor = 'pointer';
		addEventHandler(li, 'click', pageMove, lastpage, divCd);
		a.appendChild(tt);
		li.appendChild(a);
		ul_sub3.appendChild(li);
		ul.appendChild(ul_sub3);
		}

		ul.className = 'pg';
		if(divCd =="M"){
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		}else if(divCd =="B"){
			// @ts-ignore
			document.getElementById('pageNaviCorp').appendChild(ul);
		}

	} catch (ex) {
		// @ts-ignore
		console.log(ex.message);
	}
	}
	
	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number, divCd:string) {
		if(divCd =="M"){
			// @ts-ignore
			SubjManageList.goToPageByIndex(cPage);
		 }else if(divCd =="C"){
			// @ts-ignore
			SubjCodePop.goToPageByIndex(cPage);
		 }else if(divCd =="B"){
			// @ts-ignore
			SubjCorpPop.goToPageByIndex(cPage);
		 }

	
	}
	
	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param, param2) {
	if (obj.addEventListener) { // all browsers except IE before version 9
		obj.addEventListener(evtName, function () { func(param ,param2); }, false);
	} else if (obj.attachEvent) { // IE before version 9
		obj.attachEvent('on' + evtName, function () { func(param ,param2); });
	}
	}

	//통계목 코드 등록
	async function codeCreate(){
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			let param = {
				"YYYY":codeYyyy
				,"ANCT_DIV_CD":codeAnctDivCd
				,"ANCT_CD":codeAnctCd
				,"ANCT_NM":codeAnctNm
			}

			//console.log("codeCreate : "+ JSON.stringify(param));
			
			const response:any = await CommonUtil.execute({
				url:'adm_6610_codeCreate',
				data: param
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			
			if (response) {
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				modaladm6613.close();
			}
		}
		
	}

	//리스트에 변경내용 삭제
	async function codeDelete (){

		if(await UIUtils.confirm(message.get("common.message.delete.confirm", "삭제하시겠습니까?"))){
			let deleteItems: {YYYY:string; BIZ_CD:string;ANCT_TP_CD:string; ANCT_A_CD:string; ANCT_B_CD:string; ANCT_C_CD:string;}[] = [];
			
			// @ts-ignore
			let deleteItem: { YYYY:string; BIZ_CD:string;ANCT_TP_CD:string; ANCT_A_CD:string; ANCT_B_CD:string; ANCT_C_CD:string;} = {};

			// @ts-ignore
			var rows = SubjManageList.getDataRows();
			for (var i = 0; i < rows.length; i++) {	
				if ( rows[i]["Changed"] !== undefined && rows[i]["Changed"]  === 1  ){
					
					// @ts-ignore
					deleteItem = {
						YYYY: rows[i]["YYYY"],
						BIZ_CD: rows[i]["BIZ_CD"],
						ANCT_TP_CD: rows[i]["ANCT_TP_CD"],
						ANCT_A_CD: rows[i]["ANCT_A_CD"],
						ANCT_B_CD: rows[i]["ANCT_B_CD"],
						ANCT_C_CD: rows[i]["ANCT_C_CD"]
					};
					deleteItems.push(deleteItem);
				}
			}

			let param = {
				"GUBUN":"D"
				,"SUBJ_UPDATE_LIST":deleteItems
			}

			console.log(JSON.stringify(param));
			

			const response:any = await CommonUtil.execute({
				url:'adm_6610_listUpdateOrDelete',
				data: param
			}).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			
			if (response) {
				await UIUtils.alert(message.get("common.message.delete.success", "삭제되었습니다."));
				doSearch();
			}
	
		}

	}
	//통계목 리스트에 변경내용 저장
	async function codeUpdate (){
		
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
		
			let updateItems: {YYYY:string; BIZ_CD:string;ANCT_TP_CD:string; ANCT_A_CD:string; ANCT_B_CD:string; ANCT_C_CD:string; NOTES:string;USE_YN:string;}[] = [];
			
			// @ts-ignore
			let updateItem: { YYYY:string; BIZ_CD:string;ANCT_TP_CD:string; ANCT_A_CD:string; ANCT_B_CD:string; ANCT_C_CD:string; NOTES:string;USE_YN:string; } = {};

			// @ts-ignore
			var rows = SubjManageList.getDataRows();
			for (var i = 0; i < rows.length; i++) {	
				if ( rows[i]["Changed"] !== undefined && rows[i]["Changed"]  === 1  ){
					
					// @ts-ignore
					updateItem = {
						YYYY: rows[i]["YYYY"],
						BIZ_CD: rows[i]["BIZ_CD"],
						ANCT_TP_CD: rows[i]["ANCT_TP_CD"],
						ANCT_A_CD: rows[i]["ANCT_A_CD"],
						ANCT_B_CD: rows[i]["ANCT_B_CD"],
						ANCT_C_CD: rows[i]["ANCT_C_CD"],
						NOTES: rows[i]["NOTES"],
						USE_YN: rows[i]["USE_YN"]
					};
					updateItems.push(updateItem);
				}
			}

			let param = {
				"GUBUN":"U"
				,"SUBJ_UPDATE_LIST":updateItems
			}

			//console.log(JSON.stringify(param));

			const response:any = await CommonUtil.execute({
				url:'adm_6610_listUpdateOrDelete',
				data: param
		   }).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			
			if (response) {
				console.log('adm_6413_codeSave result  : ' + JSON.stringify(response.CODE_GROUP_ID));
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				doSearch();
			}

		}
	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch();
		}
	}

	//인풋 엔터체크
	const activeCodeEnter = (e) => {
		if(e.key === "Enter") {
			codeSearch();
		}
	}

    //검색 
    async function doSearch() {
		let param = {
			"YYYY":yyyy
			,"BIZ_CD":bizCd
			,"ANCT_TP_CD":anctTpCd
			,"SEARCH_TEXT": searchText
		};
		
		const response:any = await CommonUtil.execute({
		 	url:'adm_6610_selectList',
		 	data: param
		})
       
		//전체데이터 
		let result = response.LIST;
	
		if(result != null){
			//전체ROW개수 
			totalCnt = Object.keys(result).length;
			setTotalRowCnt(Object.keys(result).length);
		}

		 // 시트에 데이터를 넣습니다.
		 SubjManageListData = result;
		 // @ts-ignore	
		 SubjManageList.loadSearchData(result);  //data 로딩 처리 
		 // @ts-ignore	
		 SubjManageList.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		 // @ts-ignore	
		 makePageIndex(SubjManageList.getPageIndex( SubjManageList.getFocusedPage()) + 1 , "M"); // 페이지 초기화
   
    }//검색

	//기업 검색 
	async function corpSearch() {
		let param = {
			 "CORP_NM":searchCorpNm
			,"BIZ_NO":searchBizNo
		};
		
		const response:any = await CommonUtil.execute({
			url:'popup_selectCorporationList',
			data: param
		})
	
		//전체데이터 
		let result = response.LIST;

		if(result != null){
			//전체ROW개수 
			totalCorpCnt = Object.keys(result).length;
			setCorpTotalRowCnt(Object.keys(result).length);
		}

		// 시트에 데이터를 넣습니다.
		SubjCorpPopData = result;
		// @ts-ignore	
		SubjCorpPop.loadSearchData(result);  //data 로딩 처리 
		// @ts-ignore	
		SubjCorpPop.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
		// @ts-ignore	
		makePageIndex(SubjCorpPop.getPageIndex( SubjCorpPop.getFocusedPage()) + 1, "B"); // 페이지 초기화

	}//기업 검색
	
	//페이지 건수별로 보기 
	const handleSelect = (e) => {
		if(e.target.name === 'showRowCnt'){  //페이지 건수별로 보기
			setShowRowCnt(e.target.value);
			rowCnt = e.target.value;
			// @ts-ignore
			if(IBSheet.SubjManageList !==undefined){
				// @ts-ignore
				IBSheet.SubjManageList.dispose();
			}	  
			ib.init.SubjManageList.Cfg.PageLength = e.target.value;
			ib.create();
			
		 }else if(e.target.name === 'corpShowRowCnt'){  //페이지 건수별로 보기
			setCorpShowRowCnt(e.target.value);
			rowCorpCnt = e.target.value;
			// @ts-ignore
			if(IBSheet.SubjCorpPop !==undefined){
				// @ts-ignore
				IBSheet.SubjCorpPop.dispose();
			}		  
			ib.init.SubjCorpPop.Cfg.PageLength = e.target.value;
			ib.createSubjCorpPop();
		}
	};
	

	//양식다운로드
	const subjTemplateDownload = () => {
		//console.log("subjTemplateDownload");
		CommonUtil.downloadTemplateFile("subjTemplate.xlsx", "통계목(양식).xlsx");
		
	};

	//통계목 업로드 현재 사용안함 
	const readUploadFile = (evt: any): void => {
		const uploadExcelFile = evt.target.files[0];
		//uploadForeExcelData(uploadExcelFile);
	};
	//통계목 업로드 현재 사용안함 
	const createElementInputFile = () => {
		const input = document.createElement("input");
		input.type = "file";
		input.onchange = readUploadFile;
		document.body.appendChild(input);
		input.click();
	};

	//코드 수정
	async function updateSubjBizCode(){

		//통계목 수정일 경우 
		if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
			let param = {
				//명칭 
				"YYYY":yyyy
				,"ANCT_DIV_CD":"C"
				,"ANCT_CD":codeAnctCd
				,"ANCT_NM":codeAnctNm

				//비고 수정
				
				,"ANCT_TP_CD":anctTpCd
				,"BIZ_CD":codeBizCd
				,"NOTES":codeNotes
				,"ANCT_A_CD":anctACd
				,"ANCT_B_CD":anctBCd
				,"ANCT_C_CD":anctCCd
				
			}

			console.log(JSON.stringify(param));
			
			const response:any = await CommonUtil.execute({
				url:'adm_6610_updateSubjBizCode',
				data: param
		   }).catch((error: {COMMON_HEAD:any}) => {
				CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
				return false;
			});

			if (response) {
				await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
				modaladm6611.close();
				modaladm6612.close();
				
				doSearch();
				//modaladm6611.open();
			}
		}
	}

  //코드 조회
  async function codeSearch() {
	let param = {
		"YYYY":searchYyyy
		,"ANCT_DIV_CD":searchCodeAnctDivCd
		,"ANCT_CD":searchCodeAcntCd
		,"ANCT_NM":searchCodeAcntNm
	}

	const response:any = await CommonUtil.execute({
		url:'adm_6610_selectSubjCodeList',
		data: param
   }).catch((error: {COMMON_HEAD:any}) => {
		CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
		return false;
	});

	//전체데이터 
	let result = response.LIST;

	if(result != null){
		//전체ROW개수 
		totalCodeCnt = Object.keys(result).length;
		setCodeTotalRowCnt(Object.keys(result).length);
	}

	// 시트에 데이터를 넣습니다.
	SubjCodePopData = result;
	// @ts-ignore	
	SubjCodePop.loadSearchData(result);  //data 로딩 처리 
	// @ts-ignore	
	SubjCodePop.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
	// @ts-ignore	
	//makePageIndex(SubjCorpPop.getPageIndex( SubjCorpPop.getFocusedPage()) + 1); // 페이지 초기화

  }	

   //코드상세에서 수정버튼 클릭시
   const codeDetailUpdateView = () =>{
	   setCodeAnctCd(anctCCd);
	   setCodeAnctNm(anctCCdNm);
	   setCodeNotes(notes);

	   modaladm6612.open();
   }

   //통계목코드 수정 
   async function updateSubjCode(reciveParam){
	//수정
	if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){

		
		let param = reciveParam;

		console.log(JSON.stringify(param));

		const response:any = await CommonUtil.execute({
			url:'adm_6610_updateSubjCode',
			data: param
	   }).catch((error: {COMMON_HEAD:any}) => {
			CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
			return false;
		});
		
		if (response) {
			await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
			doSearch();
		}
	}
	
   }

   //사업연결하기 저장
   async function userAddSubj(){

	if(anctTpCd == ""){
		await UIUtils.alert("계정유형을 선택해주세요.");
		return;
	}

	if(userAnctACd =="" || userAnctBCd =="" || userAnctCCd =="" || userBizNo ==""){
		await UIUtils.alert("필수입력값을 선택해주세요.");
		return;
	}
	

	//저장 
	if(await UIUtils.confirm(message.get("common.message.save.confirm", "저장하시겠습니까?"))){
		let paramBizCd = "";
		let paramAnctTpCd = "";
		//as-is 기준 사업이 없으면 default로 001로 지정  
		if(bizCd == '' || bizCd == undefined){
			paramBizCd = '001';
		}else {
			paramBizCd = bizCd;
		}

		if(anctTpCd == "" || anctTpCd == undefined){
			paramAnctTpCd = "C";
		}else{
			paramAnctTpCd = anctTpCd;
		}

		let param = {
			"YYYY":yyyy                    //리스트의 검색조건의 사업년도
			,"BIZ_CD":paramBizCd               //리스트의 검색조건의 사업코드 
			,"BIZ_NO":userBizNo           
			,"ANCT_A_CD":userAnctACd
			,"ANCT_B_CD":userAnctBCd
			,"ANCT_C_CD":userAnctCCd
			,"ANCT_TP_CD":paramAnctTpCd        //리스트의 검색조건의 사업유형
			,"NOTES":userNotes           
		}

		console.log(JSON.stringify(param));

		const response:any = await CommonUtil.execute({
			url:'adm_6610_addSubj',
			data: param
	   }).catch((error: {COMMON_HEAD:any}) => {
			CommonUtil.showAxiosError(error.COMMON_HEAD.CODE);
			return false;
		});

		
		if (response) {
			await UIUtils.alert(message.get("common.message.save.success", "저장되었습니다."));
			//modaladm6615Close();
		}
	}
   }
   

   //통계목 코드 조회 모달 onAfterModaladm6614 IBSheet오픈
   async function onAfterModaladm6614Open() {
		ib.createSubjCodePop();     
   }

   // 통계목 코드 조회 모달 modal6614Open 오픈
	async function modal6614Open() {
		setModaladm6614Open(true)
	}

	//통계목 코드 조회 모달 modaladm6614Close 닫기
	async function modaladm6614Close() {
		// @ts-ignore
		if(IBSheet.SubjCodePop !==undefined){
			// @ts-ignore
			IBSheet.SubjCodePop.dispose();
		}
		setModaladm6614Open(false);
	}

	
	//사업연결 모달 onAfterModaladm6616 IBSheet오픈 
	async function onAfterModaladm6615Open() {
		//필요한 공통코드 로딩.
		codeDataStore.read(
		"cfms.anctAListAll,"+yyyy,  //세부사업
		"cfms.anctBListAll,"+yyyy,  //편성목
	   "cfms.anctCListAll,"+yyyy,   //통계목
	    );
    }

    // 사업연결 모달 modal6615Open 오픈
	async function modal6615Open() {
		setModaladm6615Open(true)
	}

	//사업연결 모달 modaladm6615Close 닫기
	async function modaladm6615Close() {
		setModaladm6615Open(false);
	}

	//기업조회 모달 onAfterModaladm6616 IBSheet오픈 
	async function onAfterModaladm6616Open() {
		ib.createSubjCorpPop();
    }

   // 기업조회 모달 modal6614Open 오픈
	async function modal6616Open() {
		setModaladm6616Open(true)
	}

	//기업조회 모달 modaladm6614Close 닫기
	async function modaladm6616Close() {
		// @ts-ignore
		if(IBSheet.SubjCorpPop !==undefined){
			// @ts-ignore
			IBSheet.SubjCorpPop.dispose();
		}
		setModaladm6616Open(false);
		
	}

	//기업검색 초기화
	const userCorpNmReset =() =>{
		setUserCorpNm('');
		setUserBizNo('');
	}


	//인풋 엔터체크 기업조회
	const activeCorpEnter = (e) => {
		if(e.key === "Enter") {
			corpSearch();
		}
	}
		
   // init 
	React.useEffect(() => {
       
		//ib시트 생성
		ib.create();
		
		
		//필요한 공통코드 로딩.
		codeDataStore.read("cfms.userBizCdList,"+personId,
			"cfms.anctAListAll,"+yyyy,  //세부사업
			"cfms.anctBListAll,"+yyyy,  //편성목
		   "cfms.anctCListAll,"+yyyy,   //통계목
		   "[ATC]", "[ADC]");

        return () => {
          // @ts-ignore
          IBSheet.disposeAll(true);		  
        }
    },[])

		
	return (
		<PageContainer>
			<LayoutAside />
			<div className="fww-con">
				<Breadcrumb gnbIdx={5} lnbD1Idx={8} />
				<main className="fww-main">
					<h1 className="tx tx-hd2">통계목 관리</h1>
					<div className="sf sf-3col">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">년도</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<select value={yyyy} onChange={(e) => setYyyy(e.target.value)}>
											{yearArr.map((year) => (
												<option key={year} value={year} >
													{year}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">사업</p>
								<div className="sf-value">
								<div className="sl sl-md w100p">
									<UISelect
										firstName='all'
										value={bizCd}
										valueChanged={(value) => setBizCd(String(value))}
										codeData={codeDataStore.get("cfms.userBizCdList," + personId)}
									/>
									</div>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">계정유형</p>
								<div className="sf-value">
								<div className="sl sl-md w100p">
									<UISelect
										firstName='all'
										value={anctTpCd}
										valueChanged={(value) => setAnctTpCd(value)}
										codeData={codeDataStore.get("[ATC]")}
									/>
									</div>
								</div>
							</div>
							<div className="sf-item sf-m-1-4">
								<p className="sf-key">명칭</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} placeholder={"검색어 입력"} value={searchText} valueChanged={(value) => setSearchText(value)}  onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
					</div>
					<div className="hz-root hz-center mb25">
						<Button color="pri" size="md" onClick={() => doSearch()}>조회</Button>
					</div>
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="gray-o" size="sm"onClick={codeDelete}>삭제</Button>
							<Button color="pri-o" size="sm" onClick={codeUpdate} >저장</Button>
							<Button color="pri-o" size="sm" onClick={modaladm6613.open}>코드등록</Button>
							<Button color="pri-o" size="sm" onClick={modal6614Open}>코드조회</Button>
							<Button color="pri-o" size="sm" onClick={modal6615Open}>사업연결하기</Button>
							<Button color="gray-o" size="sm" onClick={subjTemplateDownload}>양식다운로드</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" className="" value={showRowCnt}  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>
					<div id='SubjManageListDiv' className="ibsheet">[D] IBSHEET 영역</div>
				
					<div id="pageNavi" className="pg"></div>	
				</main>
			</div>

			{/* modal - 6611 */}	
			<ModalPopup
				open={modaladm6611.isShowing}
				title="코드 상세"
				size="sm"
				onClose={modaladm6611.close}
			>
				<div className="modal-con">
					
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">년도</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={yyyy} valueChanged={(value) => setYyyy(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">계정구분</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={'통계목'} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">코드</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={anctCCd} valueChanged={(value) => setAnctCCd(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">명칭</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={anctCCdNm} valueChanged={(value) => setAnctCCdNm(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연기업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => setCorpNm(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">비고</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={notes} valueChanged={(value) => setNotes(value)} readOnly={true} />
								</div>
							</div>
						</div>
					</form>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='pri' size="md" onClick={codeDetailUpdateView}>수정</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 6612 */}	
			<ModalPopup
				open={modaladm6612.isShowing}
				title="코드 수정"
				size="sm"
				onClose={modaladm6612.close}
			>
				<div className="modal-con">
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
						<div className="fo-item fo-m-1-3">
								<p className="fo-key">년도</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={yyyy} valueChanged={(value) => setYyyy(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">계정구분</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={'통계목'} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">코드</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeAnctCd} valueChanged={(value) => setCodeAnctCd(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">명칭</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeAnctNm} valueChanged={(value) => setCodeAnctNm(value)} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연기업</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} valueChanged={(value) => setCorpNm(value)} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">비고</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeNotes} valueChanged={(value) => setCodeNotes(value)}  />
								</div>
							</div>
						</div>
					</form>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm6612.close}>취소</Button>
						<Button color='pri' size="md" onClick={updateSubjBizCode}>저장</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 6613 */}	
			<ModalPopup
				open={modaladm6613.isShowing}
				title="코드 등록"
				size="sm"
				onClose={modaladm6613.close}
			>
				<div className="modal-con">
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">년도</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<select value={codeYyyy} onChange={(e) => setCodeYyyy(e.target.value)}>
											{yearArr.map((year) => (
												<option key={year} value={year} >
													{year}
												</option>
											))}
										</select>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">계정구분</p>
								<div className="fo-value">
								<div className="sl sl-md w100p">
									<UISelect
										value={codeAnctDivCd}
										valueChanged={(value) => setCodeAnctDivCd(value)}
										codeData={codeDataStore.get("[ADC]")}
										firstName={"all"}
									/>
									</div>									
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">코드</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeAnctCd} valueChanged={(value) => setCodeAnctCd(value)}  />
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">명칭</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={codeAnctNm} valueChanged={(value) => setCodeAnctNm(value)}  />
								</div>
							</div>
						</div>
					</form>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm6613.close}>취소</Button>
						<Button color='pri' size="md" onClick={codeCreate}>저장</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 6614 */}	
			<ModalPopup
				open={modaladm6614Open}
				title="통계목 코드 목록"
				size="lg"
				onClose={() => modaladm6614Close()}
				onAfterOpen={() => onAfterModaladm6614Open()}
			 >
				<div className="modal-con">
					{/*클래스옵션: sf-1row, sf-2col*/}
					<form className="sf sf-3col">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">년도</p>
								<div className="sf-value">
									<div className="sl sl-md w100p">
										<select value={searchYyyy} onChange={(e) => setSearchYyyy(e.target.value)}>
											{yearArr.map((year) => (
												<option key={year} value={year} >
													{year}
												</option>
											))}
										</select>
									</div>

								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">코드구분</p>
								<div className="sf-value">
								<div className="sl sl-md w100p">
									<UISelect
										value={searchCodeAnctDivCd}
										valueChanged={(value) => setSearchCodeAnctDivCd(value)}
										codeData={codeDataStore.get("[ADC]")}
										firstName={"sel"}
									/>
									</div>									
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">코드번호</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={searchCodeAcntCd} valueChanged={(value) => setSearchCodeAcntCd(value)} placeholder={''} readOnly={false} onKeyEnter={(e) => activeCodeEnter(e)}/>
								</div>
							</div>
							<div className="sf-item sf-m-1-4">
								<p className="sf-key">코드명</p>
								<div className="sf-value">
								<UIInput className={'tf tf-md w100p'} value={searchCodeAcntNm} valueChanged={(value) => setSearchCodeAcntNm(value)}  placeholder={''} readOnly={false} onKeyEnter={(e) => activeCodeEnter(e)}/>
								</div>
							</div>																					
						</div>
					</form>
					<div className="hz-root hz-center mb25">
						<button className="bt" data-color="pri" data-size="md" data-hz="" type="button" onClick={codeSearch}>조회</button>
					</div>

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{codeTotalRowCnt}</em>건
						</div>
					</div>

					<div id ="SubjCodePopDiv" className="ibsheet">[D] IBSHEET 영역</div>

				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm6614Close}>닫기</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 6615 */}	
			<ModalPopup
				open={modaladm6615Open}
				title="사업연결하기"
				size="lg"
				onClose={() => modaladm6615Close()}
				onAfterOpen={() => onAfterModaladm6615Open()}
			>
				<div className="modal-con">
					<div className="fo fo-col2">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">세부사업</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
									<UISelect
										value={userAnctACd}
										valueChanged={(value) => {
											if (StringUtil.isNotEmpty(value)) {
												if (userAnctACd != null) {
													setUserAnctBCd("");
													setUserAnctCCd("");
												}
												setUserAnctACd(value);
											}
										}}
										codeData={codeDataStore.get("cfms.anctAListAll," + yyyy)}
										defaultIndex={userAnctACd == null ? 0 : undefined}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">편성목</p>
								<div className="fo-value">
								<div className="sl sl-md w100p">
									<UISelect
										value={userAnctBCd}
										valueChanged={(value) => {
											if (StringUtil.isNotEmpty(value)) {
												setUserAnctBCd("");
											}
											setUserAnctBCd(value);
										}}
										codeData={codeDataStore.get("cfms.anctBListAll," + yyyy)}
										defaultIndex={userAnctBCd == null ? 0 : undefined}
									/>
									</div>									
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">통계목</p>
								<div className="fo-value">
								<div className="sl sl-md w100p">
									<UISelect
										value={userAnctCCd}
										valueChanged={(value) => {
											if (StringUtil.isNotEmpty(value)) {
												setUserAnctCCd(value);
												setUserYyyy(yyyy);
											}
										}}
										codeData={codeDataStore.get("cfms.anctCListAll," + yyyy)}
										defaultIndex={userAnctCCd == null ? 0 : undefined}
										/>
									</div>									
								</div>
							</div>							
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">출연기업</p>
								<div className="fo-value">
									<div className="hz-root hz-gap8">
										<UIInput className={'tf tf-md tf-readonly2 w100p'} value={userCorpNm} valueChanged={(value) => setUserCorpNm(value)}  readOnly={true} />
										<Button color='gray-o' size="md" onClick={modal6616Open}>찾기</Button>
										<button type="button" className="bt-refresh" onClick={userCorpNmReset}>리프레시</button>
									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">비고사항</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'}  value={userNotes} valueChanged={(value) => setUserNotes(value)}  placeholder={''} />
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-bottom">
					<div className="hz-root hz-gap8">
						<Button color='gray-o' size="md" onClick={modaladm6615Close}>취소</Button>
						<Button color='pri' size="md" onClick={userAddSubj}>저장</Button>
					</div>
				</div>	
			</ModalPopup>

			{/* modal - 6616 */}	
			<ModalPopup
				open={modaladm6616Open}
				title="기업 검색"
				size="lg"
				onClose={() => modaladm6616Close()}
				onAfterOpen={() => onAfterModaladm6616Open()}
			>
				<div className="modal-con">
					
					<div className="sf sf-1row sf-2col mb30">
						<div className="inner">
							<div className="sf-item">
								<p className="sf-key">사업자등록번호</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={searchBizNo} valueChanged={(value) => setSearchBizNo(value)} placeholder={''} onKeyEnter={(e) => activeCorpEnter(e)}/>
								</div>
							</div>
							<div className="sf-item">
								<p className="sf-key">기업명</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={searchCorpNm} valueChanged={(value) => setSearchCorpNm(value)} placeholder={''} onKeyEnter={(e) => activeCorpEnter(e)}/>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md" data-hz="" type="button" onClick={corpSearch}>조회</button>
					</div>
					
					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{corpTotalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<div className="sl sl-sm w120">
							<select name="corpShowRowCnt" id="corpShowRowCnt" className=""  onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>

					<div id ='SubjCorpPopDiv' className="ibsheet">[D] IBSHEET 영역</div>
					<div id="pageNaviCorp" className="pg"></div>	
				</div>
			</ModalPopup>															

		</PageContainer>
	);
}
export default ContentsContainer;

